module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Beauty Filter":"Beauty Filter","Save":"Save"},"zh":{"Beauty Filter":"美颜设置","Save":"完成设置"}}')
  delete Component.options._Ctor
}
